const routingObject = {
    FAQ_PATH: '/faqs',
    LIVE_PATH: '/live',
    CONTACT_US_PATH: '/contact-us',
    REFERRAL_DASHBOARD_PATH: '/referral-dashboard',
    AUTHORIZED_SERVICE_CENTER_PATH: '/authorized-service-center',
    PRODUCT_REGISTRATION_PATH: '/product-registration',
    HELP_ME_CHOOSE_PATH: '/help-me-choose',
    MANUALS_PATH: '/manuals',
}

export default routingObject
